// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3ALpa","title":"Info_title__2t6Eg","links":"Info_links__8E7wZ","link":"Info_link__1AS_t","logo":"Info_logo__1Oa6b"};